export default {
      id: "svg-icon-confirmed-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-confirmed",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/confirmed.svg
// module id = DFdS
// module chunks = 4